import React from 'react';
import PropTypes from 'prop-types';

import './Content.pcss';

const Content = ({ children, style }) => <div style={style} className="Content">{children}</div>;
Content.defaultProps = {
  children: null,
  style: null,
};
Content.propTypes = {
  children: PropTypes.node,
  /* eslint-disable */
  style: PropTypes.object,
  /* eslint-enable */
};

const generateComponent = (name) => {
  const component = ({ children, style }) => <div style={style} className={`Content__${name}`}>{children}</div>;
  component.defaultProps = {
    children: null,
    style: null,
  };
  component.propTypes = {
    children: PropTypes.node,
    /* eslint-disable */
    style: PropTypes.object,
    /* eslint-enable */
  };
  Content[name] = component;

  return component;
};

generateComponent('Title');
generateComponent('Text');
generateComponent('Subtitle');
generateComponent('TitleLabel');
generateComponent('Button');
generateComponent('Link');

export default Content;
